module.exports = __webpack_public_path__ + "img/installment_lease_structure_infogp.8e8c7b7e.png";